export { ProductType } from '@jucy/rentals-api-client/rentals-api/models/ProductType';
